import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {getSuperAdminRole} from '../../../components/authentication/AuthUtils'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {QueryKeyManager} from '../../../query-manager/QueryKeysManager'
import {getUserConfiguration} from '../AppEndpoint'

export function setStorageAppConfiguration(data) {
    localStorage.setItem('appConfig', JSON.stringify(data))
}

export function getStorageAppConfiguration() {
    const storageAppConfig = localStorage.getItem('appConfig')

    if (!storageAppConfig || storageAppConfig === 'undefined') {
        return {}
    }

    try {
        return JSON.parse(storageAppConfig)
    } catch {
        return {}
    }
}

export const useAppConfiguration = requestorId => {
    const {appConfigKeys} = QueryKeyManager(
        QueryKeyTypes.appConfiguration,
        requestorId,
    )

    return useQuery({
        queryKey: appConfigKeys.detail({id: requestorId}),
        queryFn: () => getUserConfiguration(requestorId),
        enabled: !!requestorId && !getSuperAdminRole(),
        placeholderData: getStorageAppConfiguration() || {},
    })
}

export const useAppConfigurationCRUD = requestorId => {
    const {appConfigKeys} = QueryKeyManager(
        QueryKeyTypes.appConfiguration,
        requestorId,
    )

    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: appConfigKeys.detail({id: requestorId}),
        mutationFn: ({key, data}) => {
            queryClient.setQueryData(
                appConfigKeys.detail({id: requestorId}),
                oldData => {
                    if (!!oldData) {
                        setStorageAppConfiguration({
                            ...oldData,
                            [key]: data,
                        })

                        return {
                            ...oldData,
                            [key]: data,
                        }
                    }

                    setStorageAppConfiguration({
                        [key]: data,
                    })

                    return {
                        [key]: data,
                    }
                },
            )
        },
    })
}
